import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({
  source, alt, onClick, iconClass,
}) => (
  <div
    role="button"
    onClick={onClick}
    tabIndex={0}
    onKeyPress={onClick}
    className={iconClass}
  >
    <img src={source} alt={alt} />
  </div>
);

IconButton.defaultProps = {
  iconClass: null,
};

IconButton.propTypes = {
  source: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  alt: PropTypes.string.isRequired,
  iconClass: PropTypes.string,
};

export default IconButton;
